import React, { useMemo } from 'react'
import styled from 'styled-components';
import {motion} from 'framer-motion';
import { useState } from 'react';


const scrollDownVariants = {
  initial: {
    y: 200,
    rotate: -90
  },
  animate:{
    y:0,
    transition:{
      type: "tween",
      duration: 0.5,
      delay: 0.5,
      rotate: -90
    }
  },
  exit:{
    y:200,
    transition:{
      type: "tween",
      duration: 0.5,
      delay: 0.5
    }
  },
}
const scrollDownVariantsMobile = {
  initial: {
    y: 250,
    rotate: 90
  },
  animate:{
    y:0,
    transition:{
      type: "tween",
      duration: 0.5,
      delay: 0.5,
      rotate: 90
    }
  },
  exit:{
    y:250,
    rotate: 90,
    transition:{
      type: "tween",
      duration: 0.5,
      delay: 0.5
    }
  },
}

function ScrollDown() {

  const [variants, setVariants] = useState(scrollDownVariants);
  useMemo(()=>{
    if(window.innerWidth<500) setVariants(scrollDownVariantsMobile);
    else setVariants(scrollDownVariants);
    // console.log(variants);
  },[variants]);

  return (
    <ScrollDownWrapper
      variants={variants} initial="initial" animate="animate" exit="exit"
    >
        <p className='note' >SCROLLDOWN</p>
    </ScrollDownWrapper>
  )
}


const ScrollDownWrapper= styled(motion.div)`

    position: absolute;
    bottom: 7%;
    left: 4%;
    transform: rotateZ(-90deg);
    transform-origin: 0%;

    

    .note{
      letter-spacing: 0.2em;
      font-size: 0.8rem;
    }

    .note:before{
        content: "";
        width: 70px;
        height: 1px;
        position: absolute;
        top: 50%;
        background-color: var(--white);
        transform: translate(-70px, 0);
        
    }


    @media only screen and (max-width: 500px){
      bottom: 25%;
      left: 90%;
      transform: rotateZ(90deg);
      transform-origin: 0%;


      .note:before{
        content: "";
        width: 180px;
        height: 1px;
        position: absolute;
        top: 50%;
        background-color: var(--white);
        transform: translate(115px, 0);
    }

    }

`;

export default ScrollDown